// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 音频任务节点样式 */
.AudioTaskNode-wrapper {
  width: 320px;
}

/* 头部 */
.AudioTaskNode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.AudioTaskNode-charge {
  margin: 8px 0;
  padding: 6px 10px;
  border-radius: 6px;
  color: #92400e;
  background: #fffbeb;
  font-size: 12px;
  font-weight: 600;
}

.AudioTaskNode-task-id {
  font-size: 11px;
  color: #6c757d;
  font-family: monospace;
}

/* 状态徽章 */
.AudioTaskNode-status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AudioTaskNode-status-pending {
  background: #fef3c7;
  color: #d97706;
}

.AudioTaskNode-status-processing {
  background: #dbeafe;
  color: #2563eb;
}

.AudioTaskNode-status-completed {
  background: #d1fae5;
  color: #059669;
}

.AudioTaskNode-status-failed {
  background: #fee2e2;
  color: #dc2626;
}

/* 转存提示 */
.AudioTaskNode-transfer-hint {
  font-size: 11px;
  color: #667eea;
  background: #f0f4ff;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #d1dffb;
  margin-bottom: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* 参数展示 */
.AudioTaskNode-params {
  margin-bottom: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.AudioTaskNode-params-title {
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AudioTaskNode-params-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

.AudioTaskNode-param-item {
  font-size: 11px;
}

.AudioTaskNode-param-label {
  color: #6c757d;
  margin-right: 4px;
}

.AudioTaskNode-param-value {
  color: #212529;
  font-weight: 500;
}

.AudioTaskNode-text {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e9ecef;
}

.AudioTaskNode-text-label {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 4px;
}

.AudioTaskNode-text-content {
  font-size: 12px;
  color: #212529;
  line-height: 1.5;
  max-height: 60px;
  overflow-y: auto;
}

/* 加载状态 */
.AudioTaskNode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 12px;
}

.AudioTaskNode-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: AudioTaskNode-spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes AudioTaskNode-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.AudioTaskNode-loading-text {
  font-size: 13px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 12px;
}

.AudioTaskNode-refresh-button {
  padding: 6px 16px;
  background: white;
  color: #667eea;
  border: 1px solid #667eea;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.AudioTaskNode-refresh-button:hover {
  background: #667eea;
  color: white;
}

.AudioTaskNode-refresh-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 结果展示 */
.AudioTaskNode-results {
  margin-bottom: 12px;
}

.AudioTaskNode-results-title {
  font-size: 12px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

/* 音频播放器 */
.AudioTaskNode-player {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AudioTaskNode-audio-control {
  width: 100%;
  height: 36px;
}

.AudioTaskNode-player-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.AudioTaskNode-player-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #4b5563;
}

.AudioTaskNode-player-status {
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
}

.AudioTaskNode-player-duration {
  font-size: 12px;
  color: #6b7280;
}

.AudioTaskNode-download-button {
  padding: 6px 16px;
  border-radius: 999px;
  background: #2563eb;
  border: none;
  color: white;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.2s ease;
}

.AudioTaskNode-download-button:hover {
  background: #1d4ed8;
  transform: scale(1.05);
}

.AudioTaskNode-download-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 错误状态 */
.AudioTaskNode-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #fee;
  border-radius: 8px;
  border: 1px solid #fcc;
  margin-bottom: 12px;
}

.AudioTaskNode-error-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.AudioTaskNode-error-text {
  font-size: 13px;
  color: #c33;
  text-align: center;
  margin-bottom: 12px;
  line-height: 1.4;
}

.AudioTaskNode-retry-button {
  padding: 6px 16px;
  background: white;
  color: #c33;
  border: 1px solid #c33;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.AudioTaskNode-retry-button:hover {
  background: #c33;
  color: white;
}

.AudioTaskNode-retry-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 指标信息 */
.AudioTaskNode-metrics {
  margin-top: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.AudioTaskNode-metrics-title {
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AudioTaskNode-metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.AudioTaskNode-metric-item {
  font-size: 11px;
}

.AudioTaskNode-metric-label {
  color: #6c757d;
  margin-right: 4px;
}

.AudioTaskNode-metric-value {
  color: #212529;
  font-weight: 500;
}

/* Suno 音乐列表样式 */
.AudioTaskNode-suno-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AudioTaskNode-suno-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
}

.AudioTaskNode-suno-cover {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

.AudioTaskNode-suno-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AudioTaskNode-suno-info {
  margin-bottom: 10px;
}

.AudioTaskNode-suno-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.AudioTaskNode-suno-tags {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
}

.AudioTaskNode-suno-duration {
  font-size: 11px;
  color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/AudioTaskNode.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,YAAY;AACd;;AAEA,OAAO;AACP;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* 音频任务节点样式 */\n.AudioTaskNode-wrapper {\n  width: 320px;\n}\n\n/* 头部 */\n.AudioTaskNode-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.AudioTaskNode-charge {\n  margin: 8px 0;\n  padding: 6px 10px;\n  border-radius: 6px;\n  color: #92400e;\n  background: #fffbeb;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.AudioTaskNode-task-id {\n  font-size: 11px;\n  color: #6c757d;\n  font-family: monospace;\n}\n\n/* 状态徽章 */\n.AudioTaskNode-status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.AudioTaskNode-status-pending {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.AudioTaskNode-status-processing {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.AudioTaskNode-status-completed {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.AudioTaskNode-status-failed {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* 转存提示 */\n.AudioTaskNode-transfer-hint {\n  font-size: 11px;\n  color: #667eea;\n  background: #f0f4ff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #d1dffb;\n  margin-bottom: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n/* 参数展示 */\n.AudioTaskNode-params {\n  margin-bottom: 12px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.AudioTaskNode-params-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.AudioTaskNode-params-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.AudioTaskNode-param-item {\n  font-size: 11px;\n}\n\n.AudioTaskNode-param-label {\n  color: #6c757d;\n  margin-right: 4px;\n}\n\n.AudioTaskNode-param-value {\n  color: #212529;\n  font-weight: 500;\n}\n\n.AudioTaskNode-text {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #e9ecef;\n}\n\n.AudioTaskNode-text-label {\n  font-size: 11px;\n  color: #6c757d;\n  margin-bottom: 4px;\n}\n\n.AudioTaskNode-text-content {\n  font-size: 12px;\n  color: #212529;\n  line-height: 1.5;\n  max-height: 60px;\n  overflow-y: auto;\n}\n\n/* 加载状态 */\n.AudioTaskNode-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.AudioTaskNode-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: AudioTaskNode-spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes AudioTaskNode-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.AudioTaskNode-loading-text {\n  font-size: 13px;\n  color: #6c757d;\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.AudioTaskNode-refresh-button {\n  padding: 6px 16px;\n  background: white;\n  color: #667eea;\n  border: 1px solid #667eea;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.AudioTaskNode-refresh-button:hover {\n  background: #667eea;\n  color: white;\n}\n\n.AudioTaskNode-refresh-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* 结果展示 */\n.AudioTaskNode-results {\n  margin-bottom: 12px;\n}\n\n.AudioTaskNode-results-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n/* 音频播放器 */\n.AudioTaskNode-player {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.AudioTaskNode-audio-control {\n  width: 100%;\n  height: 36px;\n}\n\n.AudioTaskNode-player-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.AudioTaskNode-player-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.AudioTaskNode-player-status {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.AudioTaskNode-player-duration {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.AudioTaskNode-download-button {\n  padding: 6px 16px;\n  border-radius: 999px;\n  background: #2563eb;\n  border: none;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.AudioTaskNode-download-button:hover {\n  background: #1d4ed8;\n  transform: scale(1.05);\n}\n\n.AudioTaskNode-download-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* 错误状态 */\n.AudioTaskNode-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background: #fee;\n  border-radius: 8px;\n  border: 1px solid #fcc;\n  margin-bottom: 12px;\n}\n\n.AudioTaskNode-error-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.AudioTaskNode-error-text {\n  font-size: 13px;\n  color: #c33;\n  text-align: center;\n  margin-bottom: 12px;\n  line-height: 1.4;\n}\n\n.AudioTaskNode-retry-button {\n  padding: 6px 16px;\n  background: white;\n  color: #c33;\n  border: 1px solid #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.AudioTaskNode-retry-button:hover {\n  background: #c33;\n  color: white;\n}\n\n.AudioTaskNode-retry-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* 指标信息 */\n.AudioTaskNode-metrics {\n  margin-top: 12px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.AudioTaskNode-metrics-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.AudioTaskNode-metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.AudioTaskNode-metric-item {\n  font-size: 11px;\n}\n\n.AudioTaskNode-metric-label {\n  color: #6c757d;\n  margin-right: 4px;\n}\n\n.AudioTaskNode-metric-value {\n  color: #212529;\n  font-weight: 500;\n}\n\n/* Suno 音乐列表样式 */\n.AudioTaskNode-suno-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.AudioTaskNode-suno-item {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.AudioTaskNode-suno-cover {\n  width: 100%;\n  height: 120px;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.AudioTaskNode-suno-cover img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.AudioTaskNode-suno-info {\n  margin-bottom: 10px;\n}\n\n.AudioTaskNode-suno-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.AudioTaskNode-suno-tags {\n  font-size: 11px;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.AudioTaskNode-suno-duration {\n  font-size: 11px;\n  color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
